import StructureComponent from './StructureComponent'
import Context from './AppContext'
import React, { Fragment } from 'react'
import { AppProps, AppContext } from '../types'
import { extendStoreWithSubscribe } from './extendStoreWithSubscribe'
import { IPropsStore, IStructureAPI } from '@wix/thunderbolt-symbols'
import { createBatchingStrategy } from './batchingStrategy'
import ComponentsStylesOverrides from './ComponentsStylesOverrides'

function App({
	structure,
	props,
	compEventsRegistrar,
	comps,
	compControllers,
	onComponentRender,
	logger,
	translate,
	batchingStrategy = createBatchingStrategy(),
	createCompControllerArgs,
}: AppProps) {
	const contextValue: AppContext = {
		structure: extendStoreWithSubscribe<IStructureAPI>(structure, batchingStrategy),
		props: extendStoreWithSubscribe<IPropsStore>(props, batchingStrategy),
		compEventsRegistrar,
		logger,
		comps,
		compControllers,
		translate,
		onComponentRender,
		createCompControllerArgs,
	}

	return (
		<Fragment>
			<Context.Provider value={contextValue}>
				<ComponentsStylesOverrides />
				<StructureComponent key="main_MF" id="main_MF" />
			</Context.Provider>
		</Fragment>
	)
}

export default App
